export { TextInput } from './TextInput';


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/components/TextInput/index.js
// module id = 29
// module chunks = 0